import { Button, Category, Instagram } from '@hub/shared'
import { SqCallout, SqLoader, SqModal } from '@squidit/react-css'
import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import ModalEditCategoriesSocialNetworkComponent from '../modal-edit-categories-social-network/modal-edit-categories-social-network.component'
import ProfileCache from '../profile-cache/profile-cache.component'
import './card-social-network.component.scoped.scss'
import './card-social-network.component.scss'
import BoxCategories from './components/box-categories/box-categories.component'
import BoxTokenExpired from './components/box-token-expired/box-token-expired.component'
import MenuActions from './components/menu-actions/menu-actions.component'
import ProfileCategories from './components/profile-categories/profile-categories.component'
import ProfileImage from './components/profile-image/profile-image.component'
import ProfileMetrics from './components/profile-metrics/profile-metrics.component'
import SocialIcon from './components/social-icon/social-icon.component'
import SocialUsername from './components/social-username/social-username.component'
import useCardSocialNetwork, { Props } from './hooks/use-card-social-network/use-card-social-network.hook'

export default (props: Props) => {
  const {
    props: { className, socialNetworkObject, type },
    memo: { fieldsCache },
    state: {
      loadingEditCategories,
      categories,
      socialNetwork,
      openCategories,
      setOpenCategories,
      openEditCategories,
      setOpenEditCategories,
      openDeleteConfirmation,
      setOpenDeleteConfirmation,
      config,
      loadingConfig,
      loadingButtonActionModal,
      openHasCampaignModal,
      setOpenHasCampaignModal,
      menuActions,
    },
    functions: { removeProfile, onUpdateCategories, handleRenewToken, isTokenValid },
  } = useCardSocialNetwork(props)

  const navigate = useNavigate()

  const removeQueryStringFromURL = useCallback(() => {
    navigate(window.location.pathname, { replace: true })
  }, [navigate])

  const [t] = useTranslation('cardSocialNetwork')

  useEffect(() => {
    const query = new URLSearchParams(window.location.search)
    if (query.get('action') === 'renewToken' && query.get('profileId') === socialNetworkObject?.id) {
      handleRenewToken(socialNetworkObject?.id, type).then(() => {
        removeQueryStringFromURL()
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!socialNetworkObject) {
    return null
  }

  return (
    <div className={`card-social-network box ${className}`}>
      <MenuActions menuActions={menuActions} />
      <ProfileImage socialNetworkObject={socialNetworkObject} />
      <SocialIcon socialNetwork={socialNetwork} />
      <SocialUsername socialNetworkObject={socialNetworkObject} socialNetwork={socialNetwork} />
      {isTokenValid() ? (
        <ProfileMetrics socialNetworkObject={socialNetworkObject} socialNetwork={socialNetwork} />
      ) : (
        <BoxTokenExpired socialNetworkObject={socialNetworkObject} onRenewToken={handleRenewToken} type={type} />
      )}
      {isTokenValid() && !config && !loadingConfig && type === 'facebook' ? (
        <ProfileCache socialNetworkObject={socialNetworkObject as Instagram} fieldsCache={fieldsCache} type={type} />
      ) : null}
      {loadingEditCategories && isTokenValid() ? (
        <footer className="loader-wrapper">
          <SqLoader size="small" className="loader-category" />
        </footer>
      ) : null}
      {isTokenValid() && !loadingEditCategories ? (
        categories?.length ? (
          <footer className={`${openCategories ? 'open' : ''}`}>
            <ProfileCategories categories={categories} openCategories={openCategories} onSetOpenCategories={setOpenCategories} />
          </footer>
        ) : (
          <BoxCategories onSetOpenEditCategories={setOpenEditCategories} />
        )
      ) : null}

      {/* Modais */}
      <SqModal
        open={openDeleteConfirmation}
        onCloseChange={() => setOpenDeleteConfirmation(false)}
        header={<h5 className="text-left m-0">{t('confirmDelete')}</h5>}
        footer={
          <div className="actions-modal">
            <Button
              size="sm"
              inverted
              color="transparent"
              borderColor="transparent"
              textColor="var(--primary_color)"
              onClick={() => setOpenDeleteConfirmation(false)}
            >
              {t('cancel')}
            </Button>
            <Button size="sm" onClick={() => removeProfile(socialNetworkObject.id, socialNetwork)} loading={loadingButtonActionModal}>
              {t('delete')}
            </Button>
          </div>
        }
      >
        <SqCallout title={t('attention')}>{t('canNotNetUndone')}</SqCallout>
      </SqModal>
      <SqModal
        open={openHasCampaignModal}
        header={<h5 className="text-left">{t('ops')}</h5>}
        footer={<Button onClick={() => setOpenHasCampaignModal(false)}>{t('ok')}</Button>}
        onCloseChange={() => setOpenHasCampaignModal(false)}
      >
        <SqCallout title={t('attention')}>{t('hasParticipingCampaign')}</SqCallout>
      </SqModal>
      <ModalEditCategoriesSocialNetworkComponent
        socialNetwork={socialNetwork}
        open={openEditCategories}
        idSocial={socialNetworkObject.id}
        onOpenChange={(open: boolean) => setOpenEditCategories(open)}
        onCategoriesSave={(newCategories: Category[]) => onUpdateCategories(newCategories)}
        selectedCategories={categories}
      />
      {/* Fim dos Modais */}
    </div>
  )
}
